<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="210"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-divider class="mb-1" />

    <v-list dense nav>
      <router-link v-if="branding.logo" to="/patients/" style="text-decoration: none">
        <v-list-item style="width: 80%;">
          <v-img :src="branding.logo" />
        </v-list-item>
      </router-link>
      <router-link v-else to="/patients/" style="text-decoration: none">
        <v-list-item>
          <v-list-item-avatar class="align-self-center" color="white" contain>
            <v-img src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico" max-height="30" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="display-1" v-text="profile.title" />
          </v-list-item-content>
        </v-list-item>
      </router-link>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">
          <!--  -->
        </base-item-group>

        <base-item v-else :key="`item-${i}`" :item="item" />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
    <div class="drawer-footer">
      <BaseSocketStatus></BaseSocketStatus>
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";
import menuItems from "@/configs/menu";
import { getBrandingConfig } from "@/config";
import BaseSocketStatus from "@/components/base/SocketStatus.vue";
export default {
  name: "CoreDrawer",
  components: { BaseSocketStatus },
  props: {
    expandOnHover: {
      type: Boolean,
    },
  },

  data: () => ({
    allowGroupConclusion: false,
    menuItems: menuItems,
  }),

  computed: {
    branding() {
      return getBrandingConfig();
    },
    ...mapState(["barColor", "barImage"]),
    customer() {
      return this.$store.state.customer.profile;
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      const mappedItems = this.menuItems.map(this.mapItem);
      if (this.allowGroupConclusion) {
        return mappedItems;
      }
      return mappedItems.filter(el => {
        return el.to !== "/group-conclusion";
      });
    },
    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
  },
  async created() {
    // FIXME: не знаю как еще проверить наличие пациентов, в .env нет настройки с ид пользователей, не знаю что проверять
    const { data } = await this.$http.get("/v1/customers", {
      params: {
        group_conclusion_participant: 1,
        limit: 1000,
      },
    });
    this.allowGroupConclusion = (data?.data || []).length;
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'


#core-navigation-drawer
  .drawer-footer
    color: #fff
    padding: 15px
    margin-top: auto

  .v-navigation-drawer__content
    display: flex
    flex-direction: column
    width: 100%

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
